module.exports = __webpack_public_path__ + "assets/44.jpg?a09297f27805fa21360c2da06d4293f7";